export default __webpack_public_path__ + "static/media/wirtschaftsförderung.dc991a06.png";